import { Injectable, inject } from "@angular/core";
import { FormBuilder, Validators } from "@angular/forms";
import { CustomerDataFormGroupModel } from "@app/shared/models";
import { BookingStepsFormType } from "@app/shared/models/booking-steps-form-type.model";
import { IBeginBookingFlowInfo } from "../booking/begin-booking-flow-info.model";
import { ValidationPatterns } from "@app/shared/validators/ValidationPatterns";
import { phoneNumberValidator } from "@app/shared/validators/phone-number/phoneNumberValidator.directive";
import { passwordRepeatValidator } from "@app/shared/validators/password-repeat/passwordRepeatValidator.directive";
import { BookingFormStepEnum } from "@app/shared/models/booking-form-step.enum";
import { TreatmentAssingementsFormGroup } from "@app/shared/models/treatment-assignments-form-group.model";

@Injectable({ providedIn: 'root' })

export class BookingStepsFormService {

  public validFirstNameExpression = ValidationPatterns.validFirstNameExpression;
  public validInfixExpression = ValidationPatterns.validInfixExpression;
  public validLastNameExpression = ValidationPatterns.validLastNameExpression;
  public validEmailExpression = ValidationPatterns.validEmailExpression;
  public validPasswordExpression = ValidationPatterns.validPasswordExpression;
  private readonly fb = inject(FormBuilder);
  private bookingStepsForm: BookingStepsFormType;

  public buildForm(bookingFlowInfo: IBeginBookingFlowInfo): BookingStepsFormType {

    this.bookingStepsForm = this.fb.group({
      salonId: [bookingFlowInfo.salonDetails.id],
      customerData: this.buildCustomerDataFormGroup(),
      salonRemarks: [''],
      createAnAccount: [null],
      password: ['', { validators: [Validators.required, Validators.pattern(this.validPasswordExpression), Validators.minLength(8), Validators.maxLength(20)] }],
      passwordRepeat: ['', { validators: [Validators.required, Validators.pattern(this.validPasswordExpression), Validators.maxLength(20)] }],
      isNewCustomer: [bookingFlowInfo.isNewCustomer],
      treatments: [bookingFlowInfo.selectedTreatments],
      treatmentAssingments: this.fb.array<TreatmentAssingementsFormGroup>([]),
      employees: [null],
      visitSlot: [null],
      bookedWithWidget: [null],
      paymentType: [null],
      adviceRequested: [null],
      activeStep: [BookingFormStepEnum.ChooseEmployeeAndTimeSlot],
      salonOnlineBookingTermsAndConditionsUrl: [null],
      loadedWeeksTotalCount: [0],
      daySlotItem: [1]
    }, { validators: passwordRepeatValidator });
    return this.bookingStepsForm;
  }

  public buildCustomerDataFormGroup(): CustomerDataFormGroupModel {
    const customerDataFormGroup = this.fb.group({
      id: [null],
      gender: ['', { validators: [Validators.required] }],
      firstName: ['', { validators: [Validators.required, Validators.pattern(this.validFirstNameExpression)] }],
      nameInfix: ['', { validators: [Validators.pattern(this.validInfixExpression)] }],
      lastName: ['', { validators: [Validators.required, Validators.pattern(this.validLastNameExpression)] }],
      email: ['', { validators: [Validators.required, Validators.pattern(this.validEmailExpression)] }],
      mobileNumber: ['', { validators: [Validators.required, Validators.maxLength(20)], disabled: true }],
      country: [null],
    }, { validators: phoneNumberValidator });
    return customerDataFormGroup;
  }
}
